
import React from 'react'
import Photo from '../Photo'
import styled from 'styled-components'
import AnimatedGif from '../AnimatedGif'
const ImgsThirds = styled.div`
    .img-one {
        grid-area: image-1;
    }
    .img-two {
        grid-area: image-2;
    }
    .img-one-two {
        display: grid;
        grid-template-columns: [image-1] 1fr [image-2] 2fr;
        column-gap: 1rem;
        &.reverse {
            direction: rtl;
        }
    }
`

// use dir prop to reverse using direction: rtl
const ImagesThirds = ({
    dir, 
    localFile1, 
    localFile2, 
    altText1, 
    altText2,
    localFile1Ext, 
    localFile2Ext}) => {
    const reverse = dir === 'rtl' ? true : false; 
    return (
        <ImgsThirds className="row-component">
            <div className={`img-one-two ${reverse ? "reverse" : "" }`}>
                <div className="img-one">
                     {// check if gif, svg, or no file then serve up Photo
                   (!localFile1Ext === 'gif' || 'svg' || false) && <Photo localFile={localFile1} altText={altText1} /> }
                   {// check if gif, svg, or no file then serve up Photo
                   (localFile1Ext === 'gif') && <AnimatedGif src={localFile1.publicURL} altText={altText1} /> }        
                </div>
                <div className="img-two">
                    <Photo localFile={localFile2} altText={altText2} />
                </div>
            </div>
        </ImgsThirds>
    )
}

export default ImagesThirds
